import React from 'react'
import Button from '@material-ui/core/Button'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'

import '../styles/header.css'

const Header: React.FC = () => {
  return (
    <header className="main-top-nav">
      <div className="banner-container">
        <div className="back-button-container">
          <Button
            href="/"
            variant="outlined"
            style={{
              textTransform: 'none',
              color: 'white',
              borderColor: 'white',
            }}
          >
            <ArrowBackIosIcon />
            Back to PEXA
          </Button>
        </div>
        <div className="pexa-logo" />
        <div className="filler" />
      </div>
    </header>
  )
}

export default Header
